module.exports = __webpack_public_path__ + "resources/8acdf1d1218750a5e1dfc5f75b81ce12.png";